import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeGetTask } from 'selectors/tasks';

import { createChecklist } from 'actions/checklists';

import { useCanUser } from 'shared-hooks/permission';

import Checklist from 'components/Checklist';

import IconListChecks from 'icons/icon-list-checks';

const TaskChecklists = ({ id, createdBy, checklists }) => {
    const { t } = useTranslation('task');
    const canEdit = useCanUser('editTask', createdBy);

    const handleCreateClick = () => {
        createChecklist(id, {
            name: 'Untitled'
        });
    }

    if (!checklists?.length && !canEdit) {
        return null;
    }

    return (
        <div className="content-panel-section">
            <div className="section-head">
                <h4>
                    <span className="title-icon"><IconListChecks size="14px" style={{ marginTop: -1 }} /></span>

                    <span className="text">{ t('checklist.title') }</span>

                    {
                        canEdit ? (
                            <button className="btn btn-circle btn-xxsmall btn-simple btn-icon btn-colored" onClick={handleCreateClick}>+</button>
                        ) : null
                    }
                </h4>
            </div>

            {
                !checklists?.length ? (
                    <p className="dimmed-text">{ t('checklist.noEntries') }</p>
                ) : null
            }

            {
                checklists?.map(checklistId => <Checklist key={checklistId} id={checklistId} canEdit={canEdit} />)
            }
        </div>
    )

}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);

        return {
            checklists: task?.checklists,
            createdBy: task?.created_by
        }
    };
}

export default connect(makeMapStateToProps)(TaskChecklists);
